if (!customElements.get("cart-drawer")) {
	class CartDrawer extends HTMLElement {
		constructor() {
			super();
			this.addEventListener("keyup", (evt) => {
				if (evt.code === "Escape") this.close();
			});
			const overlay = this.querySelector("#CartDrawer-Overlay");
			if (overlay) overlay.addEventListener("click", this.close.bind(this));
		}

		connectedCallback() {
			document.body.addEventListener("click", this._onBodyClick.bind(this));
		}

		disconnectedCallback() {
			document.body.removeEventListener("click", this._onBodyClick.bind(this));
		}

		_onBodyClick(evt) {
			if (!evt.target.closest(".cart-open-trigger")) return;
			evt.preventDefault();
			this.open(evt.target.closest(".cart-open-trigger"));
		}

		open(triggeredBy) {
			if (triggeredBy && typeof this.setActiveElement === "function") {
				this.setActiveElement(triggeredBy);
			}
			this.classList.remove("is-empty");
			setTimeout(() => {
				this.classList.add("active");
			}, 10);
			document.body.classList.add("overflow-hidden");
			this.addEventListener(
				"transitionend",
				() => {
					const containerToTrapFocusOn = this.querySelector("#CartDrawer") || this.querySelector(".drawer__inner");
					const focusElement = this.querySelector(".drawer__close") || this.querySelector(".drawer__inner");
					if (typeof window.trapFocus === "function" && containerToTrapFocusOn) {
						window.trapFocus(containerToTrapFocusOn, focusElement);
					}
				},
				{ once: true }
			);
		}

		close() {
			this.classList.remove("active");
			if (typeof window.removeTrapFocus === "function") {
				window.removeTrapFocus(this.activeElement);
			}
			document.body.classList.remove("overflow-hidden");
		}

		getSectionsToRender() {
			return [
				{ id: "cart-drawer", selector: "#CartDrawer" }
			];
		}

		getSectionInnerHTML(html, selector) {
			selector = selector || ".shopify-section";
			const doc = new DOMParser().parseFromString(html, "text/html");
			const el = doc.querySelector(selector);
			return el ? el.innerHTML : html;
		}

		renderContents(parsedState) {
			if (!parsedState || !parsedState.sections) return;
			const sections = this.getSectionsToRender();
			sections.forEach((section) => {
				const html = parsedState.sections[section.id];
				if (!html) return;
				const target = section.selector ? this.querySelector(section.selector) : document.getElementById(section.id);
				if (!target) return;
				const innerSelector = section.selector || ".shopify-section";
				target.innerHTML = this.getSectionInnerHTML(html, innerSelector);
			});
			this.classList.remove("is-empty");
			setTimeout(() => {
				const overlay = this.querySelector("#CartDrawer-Overlay");
				if (overlay) overlay.addEventListener("click", this.close.bind(this));
			}, 0);
			this.open();
		}

		setActiveElement(element) {
			this.activeElement = element;
		}
	}
	customElements.define("cart-drawer", CartDrawer);
}
